"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_vodafone__logo__white(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "2e0d5120-7eab-41e7-a906-b04a6b9c3059",
    "data-name": "New VF Icon AW",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 283.5 283.5"
  }, props), /*#__PURE__*/React.createElement("title", null, "VF_Logo"), /*#__PURE__*/React.createElement("path", {
    d: "M216.6,28.8c-25.8,5.4-46.3,29.4-46.2,56.6a14.8,14.8,0,0,0,.2,2.3c43.2,10.5,62.7,36.6,62.9,72.6s-28.3,75.5-76.4,75.7c-38.9.1-79.5-33.1-79.6-86.5-.1-35.3,18.9-69.3,43.3-89.4s56.3-32.3,85.8-32.4a35.9,35.9,0,0,1,10.2,1.1,141.7,141.7,0,1,0,81.1,128.1A141.2,141.2,0,0,0,216.6,28.8Z",
    transform: "translate(-14.2 -15.2)",
    style: {
      fill: "#fff"
    }
  }));
}

var _default = ic_vodafone__logo__white;
exports.default = _default;